import React from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

const GameKingPrizeWinner = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content game-king PrizeWinner'>
					<img
						src={`${IMG_URL}/images/gameking/game_prize_winner.png`}
						alt='game_prize_winner'
					/>
				</div>
				{/* <div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/gameking/tit_game_10.png`}
								alt='시즌 10 게임의 왕좌 이벤트 당첨자 발표'
							/>
						</h1>
						<p>이벤트 당첨자 발표</p>
					</div>
					<div className='prize-box'>
						<div className='tip'>
							경품 지급은 당첨자 <strong>발표 후 7일 이내</strong>로<br />
							<strong>고객센터 1:1 문의</strong> 혹은{' '}
							<strong>운영자 이메일 개별 연락</strong>을 통해
							<br />
							<strong>휴대전화번호</strong>를 보내주세요
						</div>
						<ol>
							<li>
								<div className='rank'>1등</div>
								<div className='nickname'>달숭이</div>
								<div className='score'>187,820점</div>
								<div className='photo'>
									<img
										src={`${IMG_URL}/images/gameking/img_product1.png`}
										alt='도미노 피자 뉴욕 오리진M, 콜라'
									/>
								</div>
								<div className='name'>
									도미노 피자 뉴욕 오리진 M (오리지널) +콜라 1.25L, BBQ 황금
									올리브 치킨 + 콜라 1.25L
								</div>
							</li>
							<li>
								<div className='rank'>2등</div>
								<div className='nickname'>라밍</div>
								<div className='score'>176,910점</div>
								<div className='photo'>
									<img
										src={`${IMG_URL}/images/gameking/img_product2.png`}
										alt='교촌치킨 반반콤보 웨지 감자 세트'
									/>
								</div>
								<div className='name'>교촌치킨 반반콤보 웨지 감자 세트</div>
							</li>
							<li>
								<div className='rank'>3등</div>
								<div className='nickname'>오리오링</div>
								<div className='score'>176,900점</div>
								<div className='photo'>
									<img
										src={`${IMG_URL}/images/gameking/img_product3.png`}
										alt='베스킨라빈스 파인트'
									/>
								</div>
								<div className='name'>베스킨라빈스 파인트</div>
							</li>
						</ol>
					</div>
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요!</dt>
							<dd>
								이벤트에 당첨되신 분들은 꼭 당첨자 발표 7일 이내로
								마이페이지&gt;설정&gt;고객센터 1:1 문의 접수 혹은 운영자 이메일
								개별 연락을 통해 휴대 전화 번호를 보내주세요.
							</dd>
							<dd>기프티콘은 당첨자 발표 후 7일 이내에 보내드립니다.</dd>
							<dd>
								기간 내 이벤트 수령을 원하시는 휴대전화 번호를 보내주시지 않을
								경우 당첨이 취소될 수 있습니다.
							</dd>
							<dd>
								이벤트 기간 동안 닉네임 변경 시 당첨자 정보 확인이 불가하여
								당첨이 취소될 수 있습니다.
							</dd>
							<dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
							<dd>이벤트 경품은 9월 11일 이후 일괄 발송될 예정입니다.</dd>
							<dd>
								잘못된 정보로 인해 상품을 받지 못할 경우에는 경품 재전달이
								불가합니다.
							</dd>
							<dd>받으신 기프티콘은 유효기간 내에 꼭 사용해주시기 바랍니다.</dd>
						</dl>
					</div> */}
			</div>
		</div>
	);
};

export default GameKingPrizeWinner;
